import { render, staticRenderFns } from "./EditProfilePerso.vue?vue&type=template&id=75a501e8"
import script from "./EditProfilePerso.vue?vue&type=script&lang=js"
export * from "./EditProfilePerso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports